// src/context/SidebarContext.jsx
// ─────────────────────────────────────────────────────────────────────────────
// Drawer sidebar'ın açık/kapalı durumunu global olarak yönetir.
// openSidebar()  → Sidebar'ı açar  (logo tıklaması, header butonu vb.)
// closeSidebar() → Sidebar'ı kapatır
// isOpen         → Mevcut durum
// ─────────────────────────────────────────────────────────────────────────────
import React, { createContext, useContext, useState, useCallback } from "react";

const SidebarContext = createContext(null);

export function SidebarProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openSidebar  = useCallback(() => setIsOpen(true),  []);
  const closeSidebar = useCallback(() => setIsOpen(false), []);
  const toggleSidebar = useCallback(() => setIsOpen(s => !s), []);

  return (
    <SidebarContext.Provider value={{ isOpen, openSidebar, closeSidebar, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error("useSidebar must be used within SidebarProvider");
  return ctx;
}
